import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';

const RULES = [
  'Decode the clues to identify festive items, delicacies and fire crackers.',
  'Locate items at your Home / Office wherever applicable.',
  'Give the answers in chat (all 5 together).',
  'Host will spotlight you and ask you to show the items on camera.',
];

export default function Rules() {
  const navigate = useNavigate();

  return (
    <Layout title="Rules">
      <ul className="rule-list">
        {RULES.map((rule, idx) => (
          <li key={idx}>{rule}</li>
        ))}
      </ul>
      <button className="hunt-btn" onClick={() => navigate('/round-1')}>
        Next
      </button>
    </Layout>
  );
}
